import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { SearchOutlined } from "@ant-design/icons";
import { useGlobalSearch } from "../../store/GlobalSearchProvider";
import {
  compassLightGreyBackground,
  darkGreen,
  greyText,
  lightGreyOutline,
} from "../../styles";

const TriggerButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 45px;
  padding: 0 10px 0 14px;
  margin-right: 15px;
  min-width: 260px;
  border: 1px solid ${lightGreyOutline};
  border-radius: 7px;
  background: white;
  cursor: pointer;
  font-family: "Apercu";
  color: ${greyText};
  transition: border-color 100ms ease, background-color 100ms ease;

  &:hover {
    border-color: ${darkGreen};
    background: #fafbfc;
  }
`;

const TriggerLabel = styled.span`
  flex: 1;
  text-align: left;
  font-size: 13px;
`;

const Shortcut = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-family: "ApercuMono", "Apercu", monospace;
  font-size: 11px;
  color: ${greyText};
  background: ${compassLightGreyBackground};
  border: 1px solid ${lightGreyOutline};
  border-radius: 4px;
  padding: 2px 6px;
`;

const isMacPlatform = (): boolean => {
  if (typeof navigator === "undefined") return true;
  // navigator.platform is deprecated but still the most reliable synchronous signal.
  return /Mac|iPhone|iPad|iPod/i.test(navigator.platform || "");
};

export const GlobalSearchTrigger: React.FC = () => {
  const { open } = useGlobalSearch();
  const [isMac, setIsMac] = useState(true);

  useEffect(() => {
    setIsMac(isMacPlatform());
  }, []);

  return (
    <TriggerButton
      onClick={open}
      type="button"
      aria-label="Open global search"
    >
      <SearchOutlined style={{ fontSize: 16, color: greyText }} />
      <TriggerLabel>Search everything…</TriggerLabel>
      <Shortcut>{isMac ? "⌘" : "Ctrl"}&nbsp;K</Shortcut>
    </TriggerButton>
  );
};
